import { call } from '../funcStore';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import MainTabs from '../components/layout/MainTabs';
import NavSearch from '../components/layout/NavSearch';
import Trend from '../components/trends/Trend';
import LiveNow from '../components/live/LiveNow';

const styles = {
  page: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  homeMain: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '32px',
    padding: '24px',
  },
};

const SCREEN_TREND = 'trend';

function HomePage() {
  const activeScreen = call('app.getState');

  return (
    <div style={styles.page}>
      <Header />

      <MainTabs />

      <main style={styles.homeMain}>
        {activeScreen === SCREEN_TREND ? (
          <Trend/>
        ) : (
          <>
            <NavSearch />
            <LiveNow/>
          </>
        )}
      </main>

      <Footer />
    </div>
  );
}

export default HomePage;
